<!--Double navigation-->
<header>

  <!-- Sidebar navigation -->
  <mdb-sidenav #sidenav class="sn-bg-1" [fixed]="false">
    <logo>
      <li>
        <div class="d-flex justify-content-center">
          <!--<img src="assets/img/heraldica.png" class="img-fluid mt-2 white w-85">-->
          <img class="img-fluid mt-2 w-85 img-sidebar"  alt="" [src]="'data:image/jpg;base64,'+configuracion.logoSidebar" *ngIf="configuracion.logoSidebar">
        </div>
      </li>
      <!--/. Logo -->
    </logo>

    <hr style="border-color: white;">

    <links>
      <!-- Side navigation links -->
      <li>
        <perfect-scrollbar style="max-width: 600px; max-height: 350px;">
          <ul class="collapsible collapsible-accordion mt-0">
            <mdb-squeezebox [multiple]="false" aria-multiselectable="false">
              <!--<mdb-item class="no-collase">-->
              <!--<mdb-item-head mdbWavesEffect routerLink="admin-agenda" routerLinkActive="active">-->
              <!--<i class="far fa-hand-pointer"></i> Agenda-->
                <!--</mdb-item-head>-->
                <!--<mdb-item-body></mdb-item-body>-->
              <!--</mdb-item>-->
              <mdb-item class="no-collase">
                <mdb-item-head mdbWavesEffect routerLink="dashboard" routerLinkActive="active">
                  <i class="far fa-hand-pointer"></i> Dashboard
                </mdb-item-head>
                <mdb-item-body></mdb-item-body>
              </mdb-item>

              <mdb-item>
                <mdb-item-head mdbWavesEffect>
                  <i class="far fa-hand-pointer"></i> Bandeja de entrada
                </mdb-item-head>
                <mdb-item-body>
                  <ul>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="bandeja_entrada/tia"
                         routerLinkActive="active"
                         mdbWavesEffect>TIA</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="bandeja_entrada/tpv"
                         routerLinkActive="active"
                         mdbWavesEffect>TPV</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="bandeja_entrada/av"
                         routerLinkActive="active"
                         mdbWavesEffect>AV</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="bandeja_entrada/visitante"
                         routerLinkActive="active"
                         mdbWavesEffect>VISITANTE</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="bandeja_entrada/TiaVisitante"
                         routerLinkActive="active"
                         mdbWavesEffect>TIA VISITANTE</a>
                    </li>
                  </ul>
                </mdb-item-body>
              </mdb-item>

              <mdb-item class="no-collase">
                <mdb-item-head mdbWavesEffect routerLink="motivos_rechazo" routerLinkActive="active">
                  <i class="far fa-hand-pointer"></i> Catálogo de motivos de rechazo
                </mdb-item-head>
                <mdb-item-body></mdb-item-body>
              </mdb-item>

              <mdb-item>
                <mdb-item-head mdbWavesEffect>
                  <i class="fa fa-inbox"></i> Administración de flujos
                </mdb-item-head>
                <mdb-item-body>
                  <ul>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="bpm_tramites/flujos"
                         routerLinkActive="active"
                         mdbWavesEffect>Flujos</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="catalogo_categorias"
                         routerLinkActive="active"
                         mdbWavesEffect>Catálogo de categorías</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="catalogo_tramites"
                         routerLinkActive="active"
                         mdbWavesEffect>Catálogo de trámites</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="cursos/cursos"
                         routerLinkActive="active"
                         mdbWavesEffect>Catálogo de cursos</a>
                    </li>
                  </ul>
                </mdb-item-body>
              </mdb-item>
              <mdb-item>
                <mdb-item-head mdbWavesEffect>
                  <i class="fa fa-inbox"></i> Administración de usuarios
                </mdb-item-head>
                <mdb-item-body>
                  <ul>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="adm_roles"
                         routerLinkActive="active"
                         mdbWavesEffect>Catálogo de roles</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="adm_usuarios"
                         routerLinkActive="active"
                         mdbWavesEffect>Catálogo de usuarios</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="adm_areas"
                         routerLinkActive="active"
                         mdbWavesEffect>Catálogo de áreas</a>
                    </li>
                  </ul>
                </mdb-item-body>
              </mdb-item>

              <!--mdb-item>
                <mdb-item-head mdbWavesEffect>
                  <i class="fa fa-inbox"></i> Administración de trámites
                </mdb-item-head>
                <mdb-item-body>
                  <ul>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="catalogo_resolutivos"
                         routerLinkActive="active"
                         mdbWavesEffect>Catálogo de Resolutivos</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="catalogo_seccionresolutivos"
                         routerLinkActive="active"
                         mdbWavesEffect>Catálogo de Secciones Resolutivos</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="catalogo_etiqresolutivos"
                         routerLinkActive="active"
                         mdbWavesEffect>Catálogo de Etiquetas Resolutivos</a>
                    </li>
                  </ul>
                </mdb-item-body>
              </mdb-item-->

              <!-- Collapsible link -->
              <mdb-item class="no-collase">
                <mdb-item-head mdbWavesEffect routerLink="carga_masiva_tias" routerLinkActive="active">
                  <i class="far fa-hand-pointer"></i> Carga Masiva de TIAS
                </mdb-item-head>
                <mdb-item-body></mdb-item-body>
              </mdb-item>
              <mdb-item>
                <mdb-item-head mdbWavesEffect>
                  <i class="fa fa-inbox"></i> Configuración del portal
                </mdb-item-head>
                <mdb-item-body>
                  <ul>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="configuracion_general"
                         routerLinkActive="active"
                         mdbWavesEffect>Configuración general</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="banners"
                         routerLinkActive="active"
                         mdbWavesEffect>Avisos del portal</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="noticias"
                         routerLinkActive="active"
                         mdbWavesEffect>Noticias</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="configuracion_tarjeta/tia"
                         routerLinkActive="active"
                         mdbWavesEffect>Configuración de tarjeta TIA</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="configuracion_tarjeta/tpv"
                         routerLinkActive="active"
                         mdbWavesEffect>Configuración de tarjeta TPV</a>
                    </li>
                  </ul>
                </mdb-item-body>
              </mdb-item>

              <!--mdb-item class="no-collase">
                <mdb-item-head mdbWavesEffect routerLink="configuracion_chat" routerLinkActive="active">
                  <i class="far fa-hand-pointer"></i> Configuración del chat
                </mdb-item-head>
                <mdb-item-body></mdb-item-body>
              </mdb-item-->



              <mdb-item>
                <mdb-item-head mdbWavesEffect>
                  <i class="fa fa-inbox"></i> Control de tarjetas
                </mdb-item-head>
                <mdb-item-body>
                  <ul>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="control-tarjetas/tia"
                         routerLinkActive="active"
                         mdbWavesEffect>Control de tarjeta TIA</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="control-tarjetas/tpv"
                         routerLinkActive="active"
                         mdbWavesEffect>Control de tarjeta TPV</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="control-tarjetas/av"
                         routerLinkActive="active"
                         mdbWavesEffect>Control de tarjeta AV</a>
                    </li>
                  </ul>
                </mdb-item-body>
              </mdb-item>

              <mdb-item>
                <mdb-item-head mdbWavesEffect>
                  <i class="fa fa-inbox"></i> Control de acceso
                </mdb-item-head>
                <mdb-item-body>
                  <ul>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="control-acceso"
                         disabled="true"
                         routerLinkActive="active"
                         mdbWavesEffect>Acceso</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="control-acceso/tpv"
                         disabled="true"
                         routerLinkActive="active"
                         mdbWavesEffect>Acceso TPV</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="control-acceso/av"
                         disabled="true"
                         routerLinkActive="active"
                         mdbWavesEffect>Acceso AV</a>
                    </li>

                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="registro-visitantes"
                         routerLinkActive="active"
                         mdbWavesEffect>Registro de visitantes</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="color-tarjeta"
                         routerLinkActive="active"
                         mdbWavesEffect>Catálogo de colores</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="zonas-aiq"
                         routerLinkActive="active"
                         mdbWavesEffect>Catálogo de zonas</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="cnf-folio"
                         routerLinkActive="active"
                         mdbWavesEffect>Catálogo de folios</a>
                    </li>

                  </ul>
                </mdb-item-body>
              </mdb-item>

              <mdb-item>
                <mdb-item-head mdbWavesEffect>
                  <i class="fa fa-inbox"></i> Control de baja
                </mdb-item-head>
                <mdb-item-body>
                  <ul>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="control-tarjetas/tia-baja"
                         routerLinkActive="active"
                         mdbWavesEffect>Control de Baja TIA</a>
                    </li>

                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="control-tarjetas/tpv-baja"
                         routerLinkActive="active"
                         mdbWavesEffect>Control de Baja TPV</a>
                    </li>

                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="control-tarjetas/av-baja"
                         routerLinkActive="active"
                         mdbWavesEffect>Control de Baja AV</a>
                    </li>


                  </ul>
                </mdb-item-body>
              </mdb-item>

              <mdb-item>
                <mdb-item-head mdbWavesEffect>
                  <i class="fa fa-inbox"></i> Control de bitácoras
                </mdb-item-head>
                <mdb-item-body>
                  <ul>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="bitacora-ca"
                         routerLinkActive="active"
                         mdbWavesEffect>Bitácora CA</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="bitacora-ca/tpv"
                         routerLinkActive="active"
                         mdbWavesEffect>Bitácora TPV</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="bitacora-ca/av"
                         routerLinkActive="active"
                         mdbWavesEffect>Bitácora AV</a>
                    </li>

                  </ul>
                </mdb-item-body>
              </mdb-item>

              <mdb-item class="no-collase">
                <mdb-item-head mdbWavesEffect routerLink="persona-boletinada" routerLinkActive="active">
                  <i class="far fa-hand-pointer"></i> Persona boletinada
                </mdb-item-head>
                <mdb-item-body></mdb-item-body>
              </mdb-item>

              <mdb-item class="no-collase">
                <mdb-item-head mdbWavesEffect routerLink="bitacora" routerLinkActive="active">
                  <i class="far fa-hand-pointer"></i> Bitácora de movimientos
                </mdb-item-head>
                <mdb-item-body></mdb-item-body>
              </mdb-item>

              <mdb-item class="no-collase">
                <mdb-item-head mdbWavesEffect routerLink="cancelacion" routerLinkActive="active">
                  <i class="far fa-hand-pointer"></i> Cancelación de solicitudes
                </mdb-item-head>
                <mdb-item-body></mdb-item-body>
              </mdb-item>

              <mdb-item>
                <mdb-item-head mdbWavesEffect>
                  <i class="fa fa-inbox"></i> Reportes
                </mdb-item-head>
                <mdb-item-body>
                  <ul>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="reportes/tramites"
                         routerLinkActive="active"
                         mdbWavesEffect>Tramites TIA</a>
                    </li>

                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="reportes/tramites-tpv"
                         routerLinkActive="active"
                         mdbWavesEffect>Tramites TPV</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="reportes/tramites-av"
                         routerLinkActive="active"
                         mdbWavesEffect>Tramites AV</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="reportes/tramites-vis"
                         routerLinkActive="active"
                         mdbWavesEffect>Tramites Visitante</a>
                    </li>
                    <li>
                      <a href="#" class="waves-effect"
                         routerLink="reportes/bitacora-tia"
                         routerLinkActive="active"
                         mdbWavesEffect>Bitácora TIA</a>
                    </li>
                  </ul>

                </mdb-item-body>
              </mdb-item>
              <!--
              <mdb-item class="no-collase">
                <mdb-item-head mdbWavesEffect routerLink="asignacion-pagos" routerLinkActive="active">
                  <i class="far fa-hand-pointer"></i> Asignación de pagos
                </mdb-item-head>
                <mdb-item-body></mdb-item-body>
              </mdb-item>-->
              <!-- Simple link -->
              <mdb-item class="no-collase">
                <mdb-item-head mdbWavesEffect (click)="signOut()">
                  <i class="fas fa-sign-out-alt"></i> <span class="text-danger"> Cerrar sesión</span>
                </mdb-item-head>
                <mdb-item-body></mdb-item-body>
              </mdb-item>
            </mdb-squeezebox>
          </ul>
        </perfect-scrollbar>
      </li>
      <!--/. Side navigation links -->
    </links>
    <div class="sidenav-bg mask-strong"></div>
  </mdb-sidenav>
  <!--/. Sidebar navigation -->

  <!-- Navbar -->
  <mdb-navbar SideClass="navbar fixed-top navbar-toggleable-md navbar-expand-lg scrolling-navbar double-nav"
              [containerInside]="false">

    <navlinks class="navbar-container">
      <!-- SideNav slide-out button -->
      <div class="float-left">
        <a (click)="sidenav.show()" class="button-collapse hidden-nav-button-collapse">
          <i class="fa fa-bars"></i>
        </a>
      </div>
      <!--/. SideNav slide-out button -->
    </navlinks>

    <navlinks>
      <ul class="nav navbar-nav nav-flex-icons ml-auto ie-double-nav ie-hidden-double-nav">
        <li class="nav-item">
          <a class="nav-link waves-light" mdbWavesEffect (click)="accountComponent.modal.show()">
            <i class="fa fa-user"></i>
            <span class="clearfix d-none d-sm-inline-block"> &nbsp;Hola, {{ user?.correo }}</span>
          </a>
        </li>
      </ul>
    </navlinks>
  </mdb-navbar>
  <!--/. Navbar -->

</header>
<!--/.Double navigation-->
<app-data-user #accountComponent></app-data-user>
